/* global L, mo, mod_tickets */

$(function(){
// открыть окно с сообщениями
    $('#top_panel').on('click', '.messages', function(event){
        var Pos = $(this).position();
        var $messages_popup = $('#messages_popup');
        var messages_popup_width = $messages_popup.outerWidth();

        var popupPos = {
            top: Pos.top + 60,
            left: Pos.left + 23
        };
        $messages_popup
        .css(popupPos);

        $messages_popup.show();

        var diff = $(window).width() - ($messages_popup.offset().left + messages_popup_width);
        if(diff < 0){
            $messages_popup.css({
                left: Math.ceil(popupPos.left + diff)
            });
        }

        var opened = true;

        $(document).bind('click.showMessages', function(event){
            if(!opened && $(event.target).closest('#messages_popup').length == 0){
                $messages_popup.hide();
                $(document).unbind('click.showMessages');
            }
            opened = false;
        });
        event.preventDefault();
    });

    // переключалка табов
    $('#messages_popup .tab_menu a').click(function(event){
        event.preventDefault();
        var tabID = $(this).attr('href');
        $(this).addClass('active').siblings('a').removeClass('active');
        $('#messages_popup ' + tabID).addClass('active').siblings('.tab').removeClass('active');
    });
});